import React, { useState, useEffect } from "react";
import {
  CalendarMonth,
  Download,
  HighlightOffRounded,
  Search,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import {
  Form,
  Button,
  Navbar,
  Container,
  Card,
  ListGroup,
  Row,
  Modal,
  InputGroup,
  Col,
} from "react-bootstrap";
import "./student_form.css";
import SwiperCore, { Pagination, Navigation } from "swiper";
import { Pagination as MuiPagination } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import "swiper/css/navigation";
import Swal from "sweetalert2";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import moment from "moment";
import "moment/locale/th";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import th from "date-fns/locale/th";
import { format } from "date-fns";
import Loader from "../../components/Loader";
import config from "../../assets/api/config";
import logo from "../../assets/logo.webp";
import pdfFile from "./pdfFile.pdf";

registerLocale("th", th);
SwiperCore.use([Pagination, Navigation]);
moment.locale("th");

const Student_Form = () => {
  const [activityName, setActivityName] = useState("");
  const [activityYear, setActivityYear] = useState("");
  const [semesterOptions, setSemesterOptions] = useState([]);
  const [activityType, setActivityType] = useState("");
  const [activityPlace, setActivityPlace] = useState("");
  const [activityDate, setActivityDate] = useState("");
  const [formattedDate, setFormattedDate] = useState("");
  const [activityTarget, setActivityTarget] = useState([]);
  const [activityPosition, setActivityPosition] = useState("");
  const [activityPictures, setActivityPictures] = useState([]);
  const [activityDocument, setActivityDocument] = useState("");
  const [bloodStatus, setBloodStatus] = useState("");
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [activityHours, setActivityHours] = useState(null);
  const [selectedDates, setSelectedDates] = useState([]);
  const [teacherForm, setTeacherForm] = useState([]);
  const [hoursOnline, setHoursOnline] = useState([]);
  const [hoursOutside, setHoursOutside] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [checkInside, setCheckInside] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activityTimes, setActivityTimes] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [facultyList, setFacultyList] = useState([]);
  const [institution, setInstitution] = useState([]);
  const [searchQuery, setSearchQuery] = useState({
    activityYear: "",
    department: "",
  });

  const [errors, setErrors] = useState({});

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const ciphertext = decodeURIComponent(params.get("q"));
  const bytes = CryptoJS.AES.decrypt(ciphertext, "secret key 123");
  const plaintext = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

  const [user_id] = useState(plaintext.user_id);
  const [fullname] = useState(plaintext.fullname);
  const [fac_name] = useState(plaintext.fac_name);
  const [maj_name] = useState(plaintext.maj_name);
  const navigate = useNavigate();
  const itemsPerPageDesktop = 8; // Number of items to display per page on desktop
  const itemsPerPageMobile = 4;
  const [itemsPerPage, setItemsPerPage] = useState(itemsPerPageDesktop);
  const [currentPage, setCurrentPage] = useState(1);
  const MAX_PDF_SIZE_MB = 25;

  const hostName = config.hostName;

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/VuVolunteer");
      return;
    }
  }, []);

  useEffect(() => {
    fetch(`${hostName}/student_form_check?student_id=${user_id}`)
      .then((response) => response.json())
      .then((data) => {
        setCheckInside(data);
      })
      .catch((error) => console.error(error));
  }, [refresh]);

  useEffect(() => {
    if (startTime && endTime) {
      const diff = moment(endTime).diff(moment(startTime), "hours");
      if (activityType === 'กิจกรรมจิตอาสาเข้าร่วมด้วยตนเอง') {
        if (diff > 4) {
          setActivityHours(4);
        } else {
          setActivityHours(diff);
        }
      } else {
        if (diff > 6) {
          setActivityHours(6);
        } else {
          setActivityHours(diff);
        }
      }

    } else {
      setActivityHours(null);
    }
  }, [startTime, endTime]);

  useEffect(() => {
    fetch(`https://i.vu.ac.th/php_api/faculty_api?factype=1`)
      .then((response) => response.json())
      .then((data) => {
        setFacultyList(data);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    fetch(`https://i.vu.ac.th/php_api/faculty_api?factype=0`)
      .then((response) => response.json())
      .then((data) => {
        setInstitution(data);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setItemsPerPage(itemsPerPageMobile); // Use 3 items on mobile
      } else {
        setItemsPerPage(itemsPerPageDesktop); // Use 9 items on desktop
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://i.vu.ac.th/research_api/semester-year`
        ); // Update the URL accordingly
        const data = await response.json();
        setSemesterOptions(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    let parsedValue = value;

    // Check if the value is a JSON string and parse it if so
    try {
      parsedValue = JSON.parse(value);
    } catch (error) {
      // Handle parsing error if necessary
    }

    setSearchQuery({
      ...searchQuery,
      [name]: parsedValue,
    });
  };

  const handleSearchSubmit = () => {
    setLoading(true);
    // Construct the query parameters based on the selected values
    let queryParams = "";
    if (searchQuery.department) {
      queryParams += `department=${searchQuery.department}&`;
    }
    if (searchQuery.institution) {
      queryParams += `institution=${searchQuery.institution}&`;
    }
    if (activityYear) {
      queryParams += `activity_year=${activityYear}&`;
    }

    // Remove trailing '&' character if any
    if (queryParams.endsWith("&")) {
      queryParams = queryParams.slice(0, -1);
    }

    // Construct the URL with the query parameters
    const url = `${hostName}/student_form_check_search/?${queryParams}`;

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        data.sort((a, b) => b.t_id - a.t_id);
        // Process the search results
        if (data.length === 0) {
          setTeacherForm("no_data"); // Set teacherForm to 0 to indicate no data available
          setCurrentPage(1);
          setLoading(false);
        } else {
          setTeacherForm(data);
          setCurrentPage(1);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const handleFormSubmit = () => {
    const errors = validateForm();
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      setLoading(true);
      if (activityDocument.size / (1024 * 1024) > MAX_PDF_SIZE_MB) {
        // Display an error message if the file size exceeds the limit
        setLoading(false);
        Swal.fire({
          icon: "error",
          text: `กรุณาอัปโหลดไฟล์ PDF ขนาดไม่เกิน ${MAX_PDF_SIZE_MB} MB`,
        });
        return; // Stop the form submission
      }
      const formData = new FormData();
      const formattedDate = format(activityDate, "yyyy-MM-dd");
      const formattedStartTime = moment(startTime).format("HH:mm");
      const formattedEndTime = moment(endTime).format("HH:mm");
      formData.append("activity_name", activityName);
      formData.append("activity_year", activityYear);
      formData.append("activity_date", formattedDate);
      formData.append("activity_hours", activityHours);
      formData.append("activity_type", activityType);
      formData.append("activity_target", [...activityTarget]);
      formData.append("activity_position", activityPosition);
      formData.append("activity_document", activityDocument);
      formData.append("student_id", user_id);
      formData.append("student_name", fullname);
      formData.append("fac_name", fac_name);
      formData.append("maj_name", maj_name);
      formData.append("start_time", formattedStartTime);
      formData.append("end_time", formattedEndTime);
      formData.append("activity_place", activityPlace);

      // Append each file to the formData
      activityPictures.forEach((file) => {
        formData.append("activity_pictures", file);
      });

      fetch(`${hostName}/student_form`, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          if (response.ok) {
            setLoading(false);
            console.log("Form submitted successfully!");
            Swal.fire({
              icon: "success",
              title: "เพิ่มข้อมูลสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                title: "thai-font",
              },
            });
            navigate(-1);
          } else if (response.status === 400) {
            response.json().then((data) => {
              setLoading(false);
              console.error("Error submitting form:", data.error);
              Swal.fire({
                icon: "warning",
                html: `
                <span style="color: black;">
                  ชั่วโมงกิจกรรมจิตอาสาเข้าร่วมด้วยตนเองจะต้องไม่เกิน 12 ชั่วโมงต่อภาคเรียน
                </span>
                <br>
                <span style="color: green;">
                  จำนวนชั่วโมงปัจจุบัน ${data.totalHours} ชั่วโมง
                </span>
              `,
                showConfirmButton: true,
                customClass: {
                  htmlContainer: "thai-font",
                },
              });
            });
          } else {
            console.error("Error submitting form");
            Swal.fire({
              icon: "error",
              text: "กรุณาใช้รูปภาพและเอกสารขนาดไม่เกิน 25 MB",
            });
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
          Swal.fire({
            icon: "error",
            text: "เกิดข้อผิดพลาดในการส่งฟอร์ม",
          });
        });
    } else {
      console.error("Error submitting form");
      setLoading(false);
      Swal.fire({
        icon: "error",
        text: "กรุณากรอกข้อมูลให้ถูกต้อง",
      });
    }
  };

  const activityTypeCheck = "กิจกรรมจิตอาสาเข้าร่วมด้วยตนเอง";
  let activityTypeText = <>{activityTypeCheck}</>;
  let activityTypeColor = "black";
  const totalHours = hoursOutside.reduce(
    (sum, item) => sum + item.activity_hours,
    0
  );
  if (totalHours >= 12) {
    activityTypeText = (
      <span style={{ color: "red" }}>{activityTypeCheck}</span>
    );
    activityTypeColor = "red";
  }

  const activityTypeCheck1 = "กิจกรรมอบรมออนไลน์จิตสาธารณะ กยศ.";
  let activityTypeText1 = <>{activityTypeCheck1}</>;
  let activityTypeColor1 = "black";
  const totalHours1 = hoursOnline.reduce(
    (sum, item) => sum + item.activity_hours,
    0
  );
  if (totalHours1 >= 6) {
    activityTypeText1 = (
      <span style={{ color: "red" }}>{activityTypeCheck1}</span>
    );
    activityTypeColor1 = "red";
  }

  const handleFormSubmitModal = () => {
    const errors = validateFormModal();
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      setLoading(true);
      const formData = new FormData();
      // const formattedDate = format(activityDate, "yyyy-MM-dd");
      formData.append("activity_name", selectedActivity.activity_name);
      formData.append("activity_date", selectedActivity.activity_date);
      formData.append("last_date", selectedActivity.last_date);
      formData.append("t_id", selectedActivity.t_id);
      formData.append("activity_year", selectedActivity.activity_year);
      formData.append("activity_hours", totalHoursAll);
      formData.append("activity_type", activityType);
      formData.append("activity_position", activityPosition);
      formData.append("student_id", user_id);
      formData.append("student_name", fullname);
      formData.append("fac_name", fac_name);
      formData.append("maj_name", maj_name);

      const timePeriodJSON = JSON.stringify(data);
      formData.append("activity_time_period", timePeriodJSON);

      // Append each file the formData
      activityPictures.forEach((file) => {
        formData.append("activity_pictures", file);
      });

      fetch(`${hostName}/student_form_inside`, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          if (response.ok) {
            setRefresh(!refresh);
            setLoading(false);
            console.log("Form submitted successfully!");
            Swal.fire({
              icon: "success",
              title: "เพิ่มข้อมูลสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                title: "thai-font",
              },
            });
            setSelectedActivity(null);
            setActivityPosition("");
            setActivityHours("");
            setActivityPictures([]);
          } else {
            console.error("Error submitting form");
            Swal.fire({
              icon: "error",
              text: "กรุณาใช้รูปภาพและเอกสารขนาดไม่เกิน 25 MB",
            });
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      setLoading(false);
      console.error("Error submitting form");
      Swal.fire({
        icon: "error",
        text: "กรุณากรอกข้อมูลให้ถูกต้อง",
      });
    }
  };

  const handleFormBlood = () => {
    const errors = validateBlood();
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      setLoading(true);
      const formData = new FormData();
      const formattedDate = format(activityDate, "yyyy-MM-dd");
      formData.append("activity_year", activityYear);
      formData.append("activity_type", activityType);
      formData.append("student_id", user_id);
      formData.append("student_name", fullname);
      formData.append("fac_name", fac_name);
      formData.append("maj_name", maj_name);
      formData.append("activity_date", formattedDate);
      formData.append("activity_hours", activityHours);
      formData.append("activity_place", activityPlace);
      formData.append("activity_position", activityPosition); //department in activity_position
      formData.append("activity_target", bloodStatus); // blood status in actiivty_target

      // Append each file the formData
      activityPictures.forEach((file) => {
        formData.append("activity_pictures", file);
      });

      fetch(`${hostName}/student_form_blood`, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          if (response.ok) {
            setLoading(false);
            console.log("Form submitted successfully!");
            Swal.fire({
              icon: "success",
              title: "เพิ่มข้อมูลสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                title: "thai-font",
              },
            });
            navigate(-1);
          } else {
            console.error("Error submitting form");
            Swal.fire({
              icon: "error",
              text: "กรุณาใช้รูปภาพและเอกสารขนาดไม่เกิน 25 MB",
            });
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      setLoading(false);
      console.error("Error submitting form");
      Swal.fire({
        icon: "error",
        text: "กรุณากรอกข้อมูลให้ถูกต้อง",
      });
    }
  };

  const handleFormOnline = () => {
    const errors = validateFormOnline();
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      setLoading(true);
      if (activityDocument.size / (1024 * 1024) > MAX_PDF_SIZE_MB) {
        // Display an error message if the file size exceeds the limit
        setLoading(false);
        Swal.fire({
          icon: "error",
          text: `กรุณาอัปโหลดไฟล์ PDF ขนาดไม่เกิน ${MAX_PDF_SIZE_MB} MB`,
        });
        return; // Stop the form submission
      }
      const formData = new FormData();
      const formattedDate = format(activityDate, "yyyy-MM-dd");
      const formattedStartTime = moment(startTime).format("HH:mm");
      const formattedEndTime = moment(endTime).format("HH:mm");
      formData.append("activity_name", activityName);
      formData.append("activity_year", activityYear);
      formData.append("activity_date", formattedDate);
      formData.append("activity_hours", activityHours);
      formData.append("activity_type", activityType);
      formData.append("activity_document", activityDocument);
      formData.append("student_id", user_id);
      formData.append("student_name", fullname);
      formData.append("fac_name", fac_name);
      formData.append("maj_name", maj_name);
      formData.append("start_time", formattedStartTime);
      formData.append("end_time", formattedEndTime);

      fetch(`${hostName}/student_form_online`, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          if (response.ok) {
            setLoading(false);
            console.log("Form submitted successfully!");
            Swal.fire({
              icon: "success",
              title: "เพิ่มข้อมูลสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                title: "thai-font",
              },
            });
            navigate(-1);
          } else if (response.status === 400) {
            response.json().then((data) => {
              setLoading(false);
              console.error("Error submitting form:", data.error);
              Swal.fire({
                icon: "warning",
                html: `
                  <span style="color: black;">
                  ชั่วโมงกิจกรรมอบรมออนไลน์จิตสาธารณะ กยศ. จะต้องไม่เกิน 6 ชั่วโมงต่อภาคเรียน
                  </span>
                  <br>
                  <span style="color: green;">
                    จำนวนชั่วโมงปัจจุบัน ${data.totalHours} ชั่วโมง
                  </span>
                `,
                showConfirmButton: true,
                customClass: {
                  htmlContainer: "thai-font",
                },
              });
            });
          } else {
            console.error("Error submitting form");
            Swal.fire({
              icon: "error",
              text: "กรุณาใช้รูปภาพและเอกสารขนาดไม่เกิน 25 MB",
            });
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      setLoading(false);
      console.error("Error submitting form");
      Swal.fire({
        icon: "error",
        text: "กรุณากรอกข้อมูลให้ถูกต้อง",
      });
    }
  };

  const handleShowModal = (activity) => {
    setSelectedActivity(activity);
    setShowModal(true);
  };

  const validateForm = () => {
    let errors = {};
    if (!activityYear) {
      errors.activityYear = "กรุณาเลือกปีการศึกษา/ภาคเรียน";
    }
    if (!activityType) {
      errors.activityType = "กรุณาเลือกประเภทกิจกรรม";
    }
    if (!activityName) {
      errors.activityName = "กรุณากรอกชื่อกิจกรรม";
    }
    if (!activityDate) {
      errors.activityDate = "กรุณาเลือกวันที่จัดกิจกรรม";
    }
    if (!activityPlace) {
      errors.activityPlace = "กรุณาเลือกวันที่จัดกิจกรรม";
    }
    if (activityTarget.length === 0) {
      errors.activityTarget = "กรุณาเลือกกลุ่มเป้าหมายของกิจกรรม";
    }
    if (!activityPosition) {
      errors.activityPosition = "กรุณากรอกรายละเอียดของกิจกรรม";
    }
    if (!activityHours) {
      errors.activityHours = "กรุณากรอกจำนวนชั่วโมงที่ทำกิจกรรม";
    }
    if (!activityPictures || activityPictures.length < 2) {
      errors.activityPictures = "กรุณาเพิ่มรูปภาพกิจกรรม 2 รูปภาพ";
    }
    if (!activityDocument || activityDocument.length === 0) {
      errors.activityDocument = "กรุณาเพิ่มเอกสารการยืนยัน";
    }

    return errors;
  };

  const validateFormOnline = () => {
    let errors = {};
    if (!activityYear) {
      errors.activityYear = "กรุณาเลือกปีการศึกษา/ภาคเรียน";
    }
    if (!activityType) {
      errors.activityType = "กรุณาเลือกประเภทกิจกรรม";
    }
    if (!activityName) {
      errors.activityName = "กรุณากรอกชื่อกิจกรรม";
    }
    if (!activityDate) {
      errors.activityDate = "กรุณาเลือกวันที่จัดกิจกรรม";
    }
    if (!activityHours) {
      errors.activityHours = "กรุณากรอกจำนวนชั่วโมงที่ทำกิจกรรม";
    }
    if (!activityDocument || activityDocument.length === 0) {
      errors.activityDocument = "กรุณาเพิ่มเอกสารการยืนยัน";
    }

    return errors;
  };

  const validateFormModal = () => {
    let errors = {};
    if (!activityPosition) {
      errors.activityPosition = "กรุณากรอกรายละเอียดของกิจกรรม";
    }
    if (!activityPictures || activityPictures.length < 2) {
      errors.activityPictures = "กรุณาเพิ่มรูปภาพกิจกรรม 2 รูปภาพ";
    }
    if (!totalHoursAll) {
      errors.totalHoursAll = "กรุณากรอกจำนวนชั่วโมง";
    }
    return errors;
  };

  const validateBlood = () => {
    let errors = {};
    if (!activityPictures || activityPictures.length < 3) {
      errors.activityPictures = "กรุณาเพิ่มรูปภาพกิจกรรม 3 รูปภาพ";
    }
    if (!activityDate) {
      errors.activityDate = "กรุณากรอกวันที่บริจาคโลหิต";
    }
    if (!activityPlace) {
      errors.activityPlace = "กรุณากรอกสถานที่บริจาคโลหิต";
    }
    if (!activityPosition) {
      errors.activityPosition = "กรุณาระบุหน่วยงาน";
    }
    if (!activityYear) {
      errors.activityYear = "กรุณาเลือกปีการศึกษา/ภาคเรียน";
    }
    if (!bloodStatus) {
      errors.bloodStatus = "กรุณาระบุสถานะการบริจาค";
    }
    return errors;
  };

  const handleDateChange = (e) => {
    setActivityDate(e);
    const date = new Date(e);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
    };
    const formattedDate = date.toLocaleDateString("th-TH", options);
    setFormattedDate(formattedDate);
  };

  const handleDeletePicture = (event, index) => {
    event.preventDefault();
    const newImages = [...activityPictures];
    newImages.splice(index, 1);
    setActivityPictures(newImages);
  };

  function isBlocked(activity) {
    return checkInside.findIndex((obj) => obj.t_id === activity.t_id) === -1;
  }

  const handleTimeChange = (time, type, activitySelectType) => {
    console.log(activitySelectType);

    if (type === "start") {
      setStartTime(time);
    } else {
      setEndTime(time);
    }

    if (startTime && endTime) {
      const diff = moment(endTime).diff(moment(startTime), "hours");
      if (activitySelectType === 'outside') {
        if (diff > 4) {
          setActivityHours(4);
        } else {
          setActivityHours(diff);
        }
      } else {
        if (diff > 6) {
          setActivityHours(6);
        } else {
          setActivityHours(diff);
        }
      }

    } else {
      setActivityHours(null);
    }
  };

  const handleDateTimeChange = (time, field, index) => {
    const newActivityTimes = [...activityTimes];
    newActivityTimes[index] = {
      ...newActivityTimes[index],
      [field]: time.format("HH:mm"),
    };
    setActivityTimes(newActivityTimes);
  };

  function calculateHours(start, end) {
    const diff = moment(end, "HH:mm:ss").diff(moment(start, "HH:mm:ss"));
    const duration = moment.duration(diff);
    const hours = duration.asHours();

    // Limit hours to 6 per day
    if (hours > 6) {
      return 6;
    }

    return Math.floor(hours); // round down to nearest integer
  }

  const data = (() => {
    const startDate = moment(selectedActivity?.activity_date);
    const endDate = moment(selectedActivity?.last_date);
    const diffDays = endDate.diff(startDate, "days") + 1;
    const dates = [];
    for (let i = 0; i < diffDays; i++) {
      const date = moment(startDate)
        .add(i, "days")
        .add(543, "years")
        .format("D MMMM YYYY");
      const times = activityTimes[i] || { start_time: null, end_time: null };
      const hours = calculateHours(times.start_time, times.end_time);
      const isChecked = times.start_time !== null;
      if (isChecked) {
        dates.push({
          activityDate: {
            date: date,
            startTime: times.start_time,
            endTime: times.end_time,
            hoursPerDay: hours,
          },
        });
      }
    }
    return dates;
  })();

  const totalHoursAll = data.reduce((acc, curr) => {
    return acc + curr.activityDate.hoursPerDay;
  }, 0);

  useEffect(() => {
    if (bloodStatus === "ผ่าน") {
      setActivityHours("6");
    } else if (bloodStatus === "ไม่ผ่าน") {
      setActivityHours("3");
    } else {
      setActivityHours("");
    }
  }, [bloodStatus]);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  function scrollToFormSection() {
    const formSection = document.getElementById("teacher-form");
    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth" });
    }
  }

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  let visibleItems = [];
  if (Array.isArray(teacherForm)) {
    visibleItems = teacherForm.slice(startIndex, endIndex);
  }

  const openPDFInNewTab = (event) => {
    event.preventDefault();
    const pdfFileURL = "https://i.vu.ac.th/volunteer_api/download-pdf"; // Replace with the actual URL to your PDF file
    const link = document.createElement("a");
    link.href = pdfFileURL;
    link.download = "แบบรับรองการทำจิตอาสา.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <div className="navbar-parent-container">
        <Navbar
          expand="lg"
          variant="light"
          style={{ backgroundColor: "#EFC001", height: "60px", width: "100vw" }}
          fluid="true"
          className="navbar"
        >
          <Container className="navbar_container" fluid>
            <Navbar.Brand>
              <img
                alt=""
                src={logo}
                style={{ width: 40, height: 40 }}
                className="d-inline-block align-top"
              />{" "}
              <span
                className="thai-font"
                style={{ fontWeight: "bold", color: "black" }}
              >
                VU Volunteer Student
              </span>
            </Navbar.Brand>
          </Container>
        </Navbar>
      </div>{" "}
      <h1
        style={{
          textAlign: "center",
          marginTop: 80,
          fontSize: 35,
          fontWeight: "bold",
        }}
        className="thai-font"
      >
        เพิ่มข้อมูลกิจกรรม
      </h1>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Form className="form_container thai-font">
          <Form.Group controlId="activityYear" className="form-group">
            <Form.Label>
              ปีการศึกษา/ภาคเรียน <span style={{ color: "red" }}>*</span>{" "}
            </Form.Label>
            <Form.Control
              as="select"
              value={activityYear}
              onChange={(e) => {
                setActivityYear(e.target.value);
              }}
            >
              <option value="">-- เลือก --</option>
              {semesterOptions.map((semester) => (
                <option key={semester.Sem_ID} value={semester.Formatted_Sem}>
                  {semester.Formatted_Sem}
                </option>
              ))}
            </Form.Control>
            {errors.activityYear && (
              <div className="text-danger">{errors.activityYear}</div>
            )}
          </Form.Group>

          <Form.Group controlId="activityType" className="form-group">
            <Form.Label>
              ประเภทกิจกรรม <span style={{ color: "red" }}>*</span>{" "}
            </Form.Label>
            <Form.Control
              as="select"
              value={activityType}
              onChange={(e) => setActivityType(e.target.value)}
            >
              <option value="">-- เลือก --</option>
              <option value="กิจกรรมโดยคณะวิชา ศูนย์ สำนัก">
                กิจกรรมที่จัดขึ้นโดยคณะวิชา ศูนย์ สํานักของมหาวิทยาลัย
                (ไม่จํากัดชั่วโมง)
              </option>
              <option
                value={activityTypeCheck}
                style={{ color: activityTypeColor }}
              >
                กิจกรรมภายนอกมหาวิทยาลัย เช่น วัด สถานที่ราชการ สาธารณะ ชุมชน
                (ไม่เกิน 12 ชม. ต่อภาค)
              </option>
              <option value="กิจกรรมการบริจาคโลหิต">
                กิจกรรมการบริจาคโลหิต (ไม่จํากัดชั่วโมง)
              </option>
              <option
                value={activityTypeCheck1}
                style={{ color: activityTypeColor1 }}
              >
                อบรมออนไลน์ผ่านเว็บไซต์กองทุน(กิจกรรมจิตสาธารณะ กยศ.) (ไม่เกิน 6
                ชม.ต่อภาค)
              </option>
            </Form.Control>
            {errors.activityType && (
              <div className="text-danger">{errors.activityType}</div>
            )}
          </Form.Group>

          {activityType === "กิจกรรมจิตอาสาเข้าร่วมด้วยตนเอง" && (
            <>
              {totalHours >= 4 ? (
                <div
                  style={{ color: "red", fontSize: 24 }}
                  className="form-group"
                >
                  คุณได้ทำ{activityTypeText}ครบ 12 ชั่วโมงในภาคเรียนนี้แล้ว
                  ไม่สามารถเพิ่มข้อมูลได้
                </div>
              ) : (
                <Form>
                  <Form.Group controlId="activityTarget" className="form-group">
                    <Form.Label>
                      ชื่อกิจกรรม <span style={{ color: "red" }}>*</span>{" "}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={activityName}
                      onChange={(e) => setActivityName(e.target.value)}
                    />
                    {errors.activityName && (
                      <div className="text-danger">{errors.activityName}</div>
                    )}
                  </Form.Group>
                  <Form.Group controlId="activityDate" className="form-group">
                    <Form.Label>
                      วันที่เข้าร่วมกิจกรรม:{" "}
                      <span style={{ color: "red" }}>*</span>{" "}
                      <span style={{ color: "green", fontWeight: "bold" }}>
                        {formattedDate}
                      </span>
                    </Form.Label>
                    <label className="date-picker">
                      <DatePicker
                        selected={activityDate}
                        onChange={handleDateChange}
                        dateFormat="dd/MM/yyyy"
                        locale="th"
                        className="form-control"
                      />
                      <CalendarMonth className="calendar-icon" />
                    </label>

                    {errors.activityDate && (
                      <div className="text-danger">{errors.activityDate}</div>
                    )}
                  </Form.Group>
                  <Form.Group controlId="activityPlace" className="form-group">
                    <Form.Label>
                      สถานที่จัดกิจกรรม <span style={{ color: "red" }}>*</span>{" "}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={activityPlace}
                      onChange={(e) => setActivityPlace(e.target.value)}
                    />
                    {errors.activityPlace && (
                      <div className="text-danger">{errors.activityPlace}</div>
                    )}
                  </Form.Group>
                  <Form.Group controlId="activityTarget" className="form-group">
                    <Form.Label>
                      กลุ่มเป้าหมายของกิจกรรม{" "}
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    {[
                      "กลุ่มนักเรียน/นักศึกษา",
                      "ผู้สูงวัย",
                      "ชุมชน",
                      "สาธารณประโยชน์",
                      "สถานที่ราชการ",
                      "บุคคลทุพพลภาพ",
                    ].map((target) => (
                      <div key={target}>
                        <Form.Check
                          style={{ fontSize: 22 }}
                          type="checkbox"
                          label={target}
                          checked={activityTarget.includes(target)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setActivityTarget([...activityTarget, target]);
                            } else {
                              setActivityTarget(
                                activityTarget.filter((t) => t !== target)
                              );
                            }
                          }}
                        />
                      </div>
                    ))}
                    {errors.activityTarget && (
                      <div className="text-danger">{errors.activityTarget}</div>
                    )}
                  </Form.Group>
                  <Form.Group
                    controlId="activityPosition"
                    className="form-group"
                  >
                    <Form.Label>
                      ตำแหน่งหน้าที่ที่ได้รับมอบหมายและปฏิบัติ{" "}
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={activityPosition}
                      onChange={(e) => setActivityPosition(e.target.value)}
                    />
                    {errors.activityPosition && (
                      <div className="text-danger">
                        {errors.activityPosition}
                      </div>
                    )}
                  </Form.Group>
                  <div
                    className="form-group"
                    style={{ fontWeight: "bold", fontSize: 22 }}
                  >
                    จำนวนชั่วโมงที่ทำกิจกรรม:{" "}
                    {activityHours && (
                      <span style={{ color: "green" }}>
                        {activityHours > 4 ? 4 : activityHours} ชั่วโมง
                      </span>
                    )}{" "}
                  </div>
                  <p
                    style={{
                      color: "black",
                      fontSize: 18,
                      fontWeight: "normal",
                      marginLeft: 10,
                    }}
                  >
                    หมายเหตุ:
                    จำนวนชั่วโมงในกิจกรรมจิตอาสาที่เข้าร่วมด้วยตนเองจะต้องไม่เกิน
                    12 ชั่วโมงต่อภาคการศึกษา
                  </p>{" "}
                  <Form.Group
                    style={{ marginLeft: 25, fontSize: 22 }}
                    controlId="activity_hours"
                    className="form-group"
                  >
                    เวลาเริ่มทำกิจกรรม <span style={{ color: "red" }}>*</span>
                    <TimePicker
                      showSecond={false}
                      defaultValue={null}
                      minuteStep={5}
                      onChange={(time) => handleTimeChange(time, "start", 'outside')}
                      style={{ fontFamily: "sans-serif" }}
                    />
                  </Form.Group>
                  <Form.Group
                    style={{ marginLeft: 25, fontSize: 22 }}
                    controlId="activity_hours"
                    className="form-group"
                  >
                    เวลาสิ้นสุดกิจกรรม <span style={{ color: "red" }}>*</span>
                    <TimePicker
                      showSecond={false}
                      defaultValue={null}
                      minuteStep={5}
                      onChange={(time) => handleTimeChange(time, "end", 'outside')}
                      style={{ fontFamily: "sans-serif" }}
                    />
                  </Form.Group>
                  {errors.activityHours && (
                    <div className="text-danger form-group">
                      {errors.activityHours}
                    </div>
                  )}
                  <Form.Group
                    controlId="activityPicture"
                    className="form-group"
                  >
                    <div style={{ pointerEvents: "none" }}>
                      <Form.Label>
                        รูปภาพกิจกรรมจำนวน 2 ภาพ{" "}
                        <span style={{ color: "red" }}>*</span>{" "}
                        <p
                          style={{
                            color: "black",
                            fontSize: 18,
                            fontWeight: "normal",
                          }}
                        >
                          หมายเหตุ:
                          รูปภาพกิจกรรมจะต้องเห็นใบหน้าของนักศึกษาขณะทำกิจกรรมอย่างชัดเจน
                          และรูปภาพต้องมีขนาดไม่เกิน 25 MB
                        </p>{" "}
                      </Form.Label>
                    </div>

                    <Form.Control
                      type="file"
                      accept="image/*"
                      multiple
                      name="activity_pictures" // add this line
                      onChange={(e) =>
                        setActivityPictures([
                          ...activityPictures,
                          ...e.target.files,
                        ])
                      }
                    />
                    <div>
                      {activityPictures.map((file, index) => (
                        <div
                          key={index}
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <img
                            src={URL.createObjectURL(file)}
                            alt={file.name}
                            style={{
                              width: 120,
                              height: 120,
                              marginTop: 10,
                              padding: 10,
                            }}
                          />
                          <button
                            onClick={(event) =>
                              handleDeletePicture(event, index)
                            }
                            style={{
                              position: "absolute",
                              marginTop: 10,
                              top: 0,
                              right: 0,
                              padding: "1px 3px",
                              borderRadius: "50%",
                              background: "red",
                              color: "white",
                              border: "none",
                              cursor: "pointer",
                            }}
                          >
                            X
                          </button>
                        </div>
                      ))}
                    </div>
                    {errors.activityPictures && (
                      <div className="text-danger">
                        {errors.activityPictures}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group
                    controlId="activityDocument"
                    className="form-group"
                  >
                    <div style={{ pointerEvents: "none" }}>
                      <Form.Label>
                        แนบแบบรับรองการทำจิตอาสาภายนอก (.pdf){" "}
                        <span style={{ color: "red" }}>*</span>
                        <p
                          style={{
                            color: "black",
                            fontSize: 18,
                            fontWeight: "normal",
                          }}
                        >
                          หมายเหตุ:
                          เอกสารยืนยันการทำกิจกรรมจะต้องมีขนาดไฟล์ไม่เกิน 25 MB
                        </p>{" "}
                      </Form.Label>
                    </div>

                    <Form.Control
                      type="file"
                      accept="application/pdf"
                      name="activity_document"
                      onChange={(e) => setActivityDocument(e.target.files[0])}
                    />
                    {errors.activityDocument && (
                      <div className="text-danger">
                        {errors.activityDocument}
                      </div>
                    )}
                  </Form.Group>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      onClick={() => handleFormSubmit()}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: "10px",
                        marginBottom: 20,
                        border: "none",
                        alignSelf: "center",
                        textAlign: "center",
                        fontSize: 20,
                      }}
                    >
                      เพิ่มข้อมูลกิจกรรม
                    </Button>
                  </div>
                </Form>
              )}
            </>
          )}
          <div className="thai-font">
            {activityType === "กิจกรรมการบริจาคโลหิต" && (
              <Form>
                <Form.Group controlId="activityDate" className="form-group">
                  <Form.Label>
                    วันที่บริจาคโลหิต: <span style={{ color: "red" }}>*</span>{" "}
                    <span style={{ color: "green", fontWeight: "bold" }}>
                      {formattedDate}
                    </span>
                  </Form.Label>
                  <label className="date-picker">
                    <DatePicker
                      selected={activityDate}
                      onChange={handleDateChange}
                      dateFormat="dd/MM/yyyy"
                      locale="th"
                      className="form-control"
                    />
                    <CalendarMonth className="calendar-icon" />
                  </label>

                  {errors.activityDate && (
                    <div className="text-danger">{errors.activityDate}</div>
                  )}
                </Form.Group>

                <Form.Group controlId="activityPosition" className="form-group">
                  <Form.Label>
                    สถานที่บริจาคโลหิต <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={activityPlace}
                    onChange={(e) => setActivityPlace(e.target.value)}
                  />
                  {errors.activityPlace && (
                    <div className="text-danger">{errors.activityPlace}</div>
                  )}
                </Form.Group>

                <Form.Group controlId="activityPosition" className="form-group">
                  <Form.Label>
                    จัดขึ้นโดยหน่วยงาน <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={activityPosition}
                    onChange={(e) => setActivityPosition(e.target.value)}
                  />
                  {errors.activityPosition && (
                    <div className="text-danger">{errors.activityPosition}</div>
                  )}
                </Form.Group>

                <Form.Group controlId="activityPosition" className="form-group">
                  <Form.Label>
                    สถานะการบริจาค <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    as="select"
                    value={bloodStatus}
                    onChange={(e) => setBloodStatus(e.target.value)}
                  >
                    <option value="">-- เลือก --</option>
                    <option value="ผ่าน">ผ่าน </option>
                    <option value="ไม่ผ่าน">ไม่ผ่าน</option>
                  </Form.Control>

                  {errors.bloodStatus && (
                    <div className="text-danger">{errors.bloodStatus}</div>
                  )}
                </Form.Group>

                <Form.Group controlId="activityHours" className="form-group">
                  <Form.Label>จำนวนชั่วโมงที่ได้รับ</Form.Label>
                  <InputGroup>
                    <Form.Control
                      disabled
                      type="number"
                      placeholder="กรอกจำนวนชั่วโมง"
                      step="1"
                      min="0"
                      value={activityHours}
                    />
                  </InputGroup>
                </Form.Group>

                <Form.Group controlId="activityPicture" className="form-group">
                  <div style={{ pointerEvents: "none" }}>
                    <Form.Label>
                      รูปภาพกิจกรรมจำนวน 3 ภาพ{" "}
                      <span style={{ color: "red" }}>*</span>{" "}
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span
                          style={{
                            color: "black",
                            fontSize: 18,
                            fontWeight: "normal",
                          }}
                        >
                          หมายเหตุ:
                          1.ภาพถ่ายการเข้าร่วมกรณีไม่ผ่านการตรวจเลือด/ภาพระหว่างบริจาค
                        </span>{" "}
                        <span
                          style={{
                            color: "black",
                            fontSize: 18,
                            fontWeight: "normal",
                          }}
                        >
                          {" "}
                          2.ภาพถ่ายบัตรประจำตัวผู้บริจาคโลหิตด้านหน้าบัตร
                          และด้านหลังบัตรที่มีลายมือชื่อเจ้าหน้าที่ประจำหน่วยบริจาค
                        </span>
                        <span
                          style={{
                            color: "black",
                            fontSize: 18,
                            fontWeight: "normal",
                          }}
                        >
                          {" "}
                          3.รูปภาพต้องมีขนาดไม่เกิน 25 MB
                        </span>
                      </div>
                    </Form.Label>
                  </div>

                  <Form.Control
                    type="file"
                    accept="image/*"
                    multiple
                    name="activity_pictures" // add this line
                    onChange={(e) =>
                      setActivityPictures([
                        ...activityPictures,
                        ...e.target.files,
                      ])
                    }
                  />
                  <div>
                    {activityPictures.map((file, index) => (
                      <div
                        key={index}
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <img
                          src={URL.createObjectURL(file)}
                          alt={file.name}
                          style={{
                            width: 120,
                            height: 120,
                            marginTop: 10,
                            padding: 10,
                          }}
                        />
                        <button
                          onClick={(event) => handleDeletePicture(event, index)}
                          style={{
                            position: "absolute",
                            marginTop: 10,
                            top: 0,
                            right: 0,
                            padding: "1px 3px",
                            borderRadius: "50%",
                            background: "red",
                            color: "white",
                            border: "none",
                            cursor: "pointer",
                          }}
                        >
                          X
                        </button>
                      </div>
                    ))}
                  </div>
                  {errors.activityPictures && (
                    <div className="text-danger">{errors.activityPictures}</div>
                  )}
                </Form.Group>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    onClick={() => handleFormBlood()}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "10px",
                      marginBottom: 20,
                      border: "none",
                      alignSelf: "center",
                      textAlign: "center",
                      fontSize: 20,
                    }}
                  >
                    เพิ่มข้อมูลกิจกรรม
                  </Button>
                </div>
              </Form>
            )}

            <div className="thai-font">
              {activityType === "กิจกรรมอบรมออนไลน์จิตสาธารณะ กยศ." && (
                <>
                  {totalHours1 >= 6 ? (
                    <div
                      style={{ color: "red", fontSize: 24 }}
                      className="form-group"
                    >
                      คุณได้ทำ{activityTypeText1}ครบ 6 ชั่วโมงในภาคเรียนนี้แล้ว
                      ไม่สามารถเพิ่มข้อมูลได้
                    </div>
                  ) : (
                    <Form>
                      <Form.Group
                        controlId="activityTarget"
                        className="form-group"
                      >
                        <Form.Label>
                          หัวข้อการเข้าอบรม{" "}
                          <span style={{ color: "red" }}>*</span>{" "}
                        </Form.Label>
                        <Form.Control
                          type="text"
                          value={activityName}
                          onChange={(e) => setActivityName(e.target.value)}
                        />
                        {errors.activityName && (
                          <div className="text-danger">
                            {errors.activityName}
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group
                        controlId="activityDate"
                        className="form-group"
                      >
                        <Form.Label>
                          วันที่เข้าร่วมการอบรม:{" "}
                          <span style={{ color: "red" }}>*</span>{" "}
                          <span style={{ color: "green", fontWeight: "bold" }}>
                            {formattedDate}
                          </span>
                        </Form.Label>
                        <label className="date-picker">
                          <DatePicker
                            selected={activityDate}
                            onChange={handleDateChange}
                            dateFormat="dd/MM/yyyy"
                            locale="th"
                            className="form-control"
                          />
                          <CalendarMonth className="calendar-icon" />
                        </label>

                        {errors.activityDate && (
                          <div className="text-danger">
                            {errors.activityDate}
                          </div>
                        )}
                      </Form.Group>
                      <div
                        className="form-group"
                        style={{ fontWeight: "bold" }}
                      >
                        <Form.Label>
                          จำนวนชั่วโมงที่เข้าอบรม:{" "}
                          {activityHours && (
                            <span style={{ color: "green" }}>
                              {activityHours > 6 ? 6 : activityHours} ชั่วโมง
                            </span>
                          )}{" "}
                        </Form.Label>
                      </div>
                      <p
                        style={{
                          color: "black",
                          fontSize: 18,
                          fontWeight: "normal",
                          marginLeft: 10,
                        }}
                      >
                        หมายเหตุ: จำนวนชั่วโมงในกิจกรรมอบรมออนไลน์จิตสาธารณะ
                        กยศ. จะต้องไม่เกิน 6 ชั่วโมงต่อภาคการศึกษา
                        และตรงตามใบเกียรติบัตรที่แนบมา
                      </p>{" "}
                      <Form.Group
                        style={{ marginLeft: 25, fontSize: 20 }}
                        controlId="activity_hours"
                        className="form-group"
                      >
                        เวลาเริ่มทำกิจกรรม{" "}
                        <span style={{ color: "red" }}>*</span>
                        <TimePicker
                          showSecond={false}
                          defaultValue={null}
                          onChange={(time) => handleTimeChange(time, "start", 'online')}
                          style={{ fontFamily: "sans-serif" }}
                        />
                      </Form.Group>
                      <Form.Group
                        style={{ marginLeft: 25, fontSize: 20 }}
                        controlId="activity_hours"
                        className="form-group"
                      >
                        เวลาสิ้นสุดกิจกรรม{" "}
                        <span style={{ color: "red" }}>*</span>
                        <TimePicker
                          showSecond={false}
                          defaultValue={null}
                          onChange={(time) => handleTimeChange(time, "end", 'online')}
                          style={{ fontFamily: "sans-serif" }}
                        />
                      </Form.Group>
                      {errors.activityHours && (
                        <div className="text-danger form-group">
                          {errors.activityHours}
                        </div>
                      )}
                      <Form.Group
                        controlId="activityDocument"
                        className="form-group"
                      >
                        <div style={{ pointerEvents: "none" }}>
                          <Form.Label>
                            หลักฐานการเข้าร่วมอบรมออนไลน์ (.pdf){" "}
                            <span style={{ color: "red" }}>*</span>
                            <p
                              style={{
                                color: "black",
                                fontSize: 18,
                                fontWeight: "normal",
                              }}
                            >
                              หมายเหตุ:
                              ขนาดไฟล์หลักฐานการเข้าร่วมอบรมออนไลน์จะต้องไม่เกิน
                              25 MB
                            </p>{" "}
                          </Form.Label>
                        </div>

                        <Form.Control
                          type="file"
                          accept="application/pdf"
                          name="activity_document"
                          onChange={(e) =>
                            setActivityDocument(e.target.files[0])
                          }
                        />
                        {errors.activityDocument && (
                          <div className="text-danger">
                            {errors.activityDocument}
                          </div>
                        )}
                      </Form.Group>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          onClick={() => handleFormOnline()}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "10px",
                            marginBottom: 20,
                            border: "none",
                            alignSelf: "center",
                            textAlign: "center",
                            fontSize: 20,
                          }}
                        >
                          เพิ่มข้อมูลกิจกรรม
                        </Button>
                      </div>
                    </Form>
                  )}
                </>
              )}
            </div>
          </div>
        </Form>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 30,
        }}
      >
        {" "}
        {activityType === "กิจกรรมโดยคณะวิชา ศูนย์ สำนัก" && (
          <>
            <div>
              <div className="content thai-font">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      maxWidth: "650px",
                      padding: "20px",
                      border: "1px solid #ccc",
                      borderRadius: "25px",
                      marginTop: "20px",
                      margin: "0 auto",
                      marginBottom: "20px",
                    }}
                  >
                    <Form>
                      <Row className="mb-3">
                        <Col xs={12} sm={6} md={4}>
                          <Form.Group controlId="department">
                            <Form.Label>คณะวิชา</Form.Label>
                            <Form.Control
                              as="select"
                              name="department" // Update the name attribute to a unique value
                              value={searchQuery.department}
                              onChange={handleSearchChange}
                            >
                              <option value="">-- ทั้งหมด --</option>
                              {facultyList.map((faculty) => (
                                <option
                                  value={faculty.Fac_ID}
                                  key={faculty.Fac_ID}
                                >
                                  {faculty.Fac_NameTH}
                                </option>
                              ))}
                            </Form.Control>
                          </Form.Group>
                        </Col>

                        <Col xs={12} md={4}>
                          <Form.Group controlId="institution">
                            <Form.Label>ศูนย์/สำนัก</Form.Label>
                            <Form.Control
                              as="select"
                              name="institution" // Update the name attribute to a unique value
                              onChange={handleSearchChange}
                              value={searchQuery.institution}
                            >
                              <option value="">-- ทั้งหมด --</option>
                              {institution.map((inst) => (
                                <option value={inst.Fac_ID} key={inst.Fac_ID}>
                                  {inst.Fac_NameTH}
                                </option>
                              ))}
                            </Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Form>
                    <Row className="mb-3 justify-content-end mt-3">
                      <Col xs={12} sm={6} md={4}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <Button
                            id="teacher-form"
                            onClick={() => handleSearchSubmit()}
                            variant="primary"
                            style={{ fontSize: 22 }}
                          >
                            <Search /> ค้นหา
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
              {teacherForm !== "no_data" ? (
                <ListGroup>
                  <Row
                    className="justify-content-center"
                    style={{ height: "auto" }}
                  >
                    {visibleItems.map((activity, index) => (
                      <Card
                        key={index}
                        className="activity-card thai-font"
                        style={{ fontSize: 20, height: "auto" }}
                      >
                        <Swiper
                          navigation={true}
                          pagination={{ clickable: true }}
                          paginationstyle={{ marginBottom: 20 }}
                        >
                          {activity.picture_data.map((picture, index) => (
                            <SwiperSlide key={index}>
                              {picture ? (
                                <Card.Img
                                  variant="top"
                                  src={`data:image/png;base64,${picture}`}
                                  className="card-img-top"
                                  style={{ height: 300 }}
                                />
                              ) : (
                                <Card.Img
                                  variant="top"
                                  src={logo}
                                  className="card-img-top"
                                  style={{ height: 300 }}
                                />
                              )}
                            </SwiperSlide>
                          ))}
                        </Swiper>

                        <Card.Header
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#E7E7E7",
                          }}
                        >
                          {activity.activity_name}
                        </Card.Header>
                        <ListGroup.Item>
                          <strong>ภาคเรียน:</strong> {activity.activity_year}
                        </ListGroup.Item>
                        <ListGroup.Item>
                          <strong>วันที่จัดกิจกรรม:</strong>{" "}
                          {new Date(activity.activity_date).toLocaleDateString(
                            "th-TH",
                            {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            }
                          )}
                        </ListGroup.Item>
                        <ListGroup.Item>
                          <strong>วันที่สิ้นสุดกิจกรรม:</strong>{" "}
                          {new Date(activity.last_date).toLocaleDateString(
                            "th-TH",
                            {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            }
                          )}
                        </ListGroup.Item>
                        <ListGroup.Item>
                          <strong>ผู้ดูแลกิจกรรม:</strong>{" "}
                          {activity.teacher_name}
                        </ListGroup.Item>
                        <ListGroup.Item>
                          <strong>กิจกรรมจัดขึ้นโดย:</strong>{" "}
                          {activity?.department &&
                            JSON.parse(activity?.department).dep_name}
                        </ListGroup.Item>
                        <ListGroup.Item className="text-center">
                          <button
                            className="btn btn-warning"
                            onClick={() => handleShowModal(activity)}
                            style={{
                              fontSize: 20,
                              color: "black",
                              fontWeight: "bold",
                            }}
                            disabled={isBlocked(activity)}
                          >
                            {isBlocked(activity)
                              ? "เข้าร่วมกิจกรรมแล้ว"
                              : "เข้าร่วมกิจกรรม"}
                          </button>
                        </ListGroup.Item>
                      </Card>
                    ))}
                  </Row>
                </ListGroup>
              ) : (
                <div style={{ color: "red" }} className="form-group thai-font">
                  ยังไม่มีข้อมูลกิจกรรมที่จัดขึ้นโดยคณะวิชา ศูนย์ สำนัก
                  ในปีการศึกษานี้
                </div>
              )}

              {teacherForm !== "no_data" && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  <MuiPagination
                    count={Math.ceil(teacherForm.length / itemsPerPage)}
                    page={currentPage}
                    onChange={(event, page) => {
                      handlePageChange(event, page);
                      scrollToFormSection(); // Scroll to the "course" section
                    }}
                    color="warning"
                  />
                </div>
              )}
            </div>
          </>
        )}
        <Modal
          show={selectedActivity !== null}
          onHide={() => {
            setSelectedActivity(null);
            setActivityPosition("");
            setActivityHours("");
            setActivityPictures([]);
            setSelectedDates([]);
            setActivityTimes([]);
          }}
          className="thai-font"
          style={{ fontSize: 20 }}
        >
          <div style={{ position: "relative" }}>
            <button
              className="btn btn-light"
              style={{ position: "absolute", top: 0, right: 0, fontSize: 20 }}
              onClick={() => {
                setSelectedActivity(null);
                setActivityPosition("");
                setActivityHours("");
                setActivityPictures([]);
              }}
            >
              <HighlightOffRounded style={{ color: "red" }} />
            </button>
            <Swiper
              navigation={true}
              pagination={{ clickable: true }}
              paginationstyle={{ marginBottom: 20 }}
            >
              {selectedActivity?.picture_data.map((picture, index) => (
                <SwiperSlide key={index}>
                  {picture ? (
                    <img
                      variant="top"
                      src={`data:image/png;base64,${picture}`}
                      className="img-fluid"
                      style={{ width: 500 }}
                    />
                  ) : (
                    <img
                      src={logo}
                      variant="top"
                      className="img-fluid"
                      style={{ width: 500 }}
                    />
                  )}
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <Modal.Title
            style={{ fontWeight: "bold", marginTop: 10, marginLeft: 10 }}
          >
            {selectedActivity?.activity_name}
          </Modal.Title>
          <hr />
          <Modal.Body>
            <p>
              <strong>ภาคเรียน:</strong> {selectedActivity?.activity_year}
            </p>
            <p>
              <strong>วันที่จัดกิจกรรม:</strong>{" "}
              {new Date(selectedActivity?.activity_date).toLocaleDateString(
                "th-TH",
                { year: "numeric", month: "long", day: "numeric" }
              )}
            </p>
            <p>
              <strong>วันที่สิ้นสุดกิจกรรม:</strong>{" "}
              {new Date(selectedActivity?.last_date).toLocaleDateString(
                "th-TH",
                { year: "numeric", month: "long", day: "numeric" }
              )}
            </p>

            <p>
              <strong>สถานที่จัดกิจกรรม:</strong>{" "}
              {selectedActivity?.activity_place}
            </p>
            <p>
              <strong>ผู้ดูแลกิจกรรม:</strong> {selectedActivity?.teacher_name}
            </p>
            <p>
              <strong>กิจกรรมจัดขึ้นโดย:</strong>{" "}
              {selectedActivity?.department &&
                JSON.parse(selectedActivity?.department).dep_name}{" "}
            </p>
            <hr />

            <Form>
              <Form.Group controlId="activityPosition" className="form-group">
                <Form.Label>
                  กรอกภาระงานหน้าที่ที่ได้รับมอบหมาย{" "}
                  <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={activityPosition}
                  onChange={(e) => setActivityPosition(e.target.value)}
                />
                {errors.activityPosition && (
                  <div className="text-danger">{errors.activityPosition}</div>
                )}
              </Form.Group>

              <Form.Group
                controlId="activitySelectedDate"
                className="form-group"
              >
                <p>
                  <strong>
                    วันที่ปฏิบัติกิจกรรม:{" "}
                    <span style={{ color: "red" }}>*</span>{" "}
                  </strong>{" "}
                  {(() => {
                    const startDate = moment(selectedActivity?.activity_date);
                    const endDate = moment(selectedActivity?.last_date);
                    const diffDays = endDate.diff(startDate, "days") + 1;
                    const dates = [];
                    for (let i = 0; i < diffDays; i++) {
                      const date =
                        moment(startDate).add(i, "days").format("D MMMM ") +
                        (moment(startDate).add(i, "days").year() + 543);
                      dates.push(date);
                    }
                    return dates.map((date, index) => {
                      const isChecked = selectedDates.includes(date);
                      const times = activityTimes[index] || {
                        start_time: null,
                        end_time: null,
                      };
                      const hours = calculateHours(
                        times.start_time,
                        times.end_time
                      );

                      return (
                        <div key={index}>
                          <input
                            style={{ marginLeft: 10, cursor: "pointer" }}
                            type="checkbox"
                            id={`date-${index}`}
                            name={`date-${index}`}
                            value={date}
                            checked={isChecked}
                            onChange={(event) => {
                              const isChecked = event.target.checked;
                              if (isChecked) {
                                setSelectedDates([...selectedDates, date]);
                                setActivityTimes([
                                  ...activityTimes,
                                  { start_time: null, end_time: null },
                                ]);
                              } else {
                                setSelectedDates(
                                  selectedDates.filter((d) => d !== date)
                                );
                                setActivityTimes(
                                  activityTimes.filter((t, i) => i !== index)
                                );
                              }
                            }}
                          />
                          <label
                            style={{ marginLeft: 10, marginTop: 10 }}
                            htmlFor={`date-${index}`}
                          >
                            {date}
                            {": "}
                            {times && times.start_time && times.end_time && (
                              <span style={{ color: "green" }}>
                                จำนวนชั่วโมง: {hours}
                              </span>
                            )}
                          </label>
                          {isChecked && (
                            <div
                              style={{
                                marginLeft: 25,
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <div>เวลาเริ่ม </div>
                              <TimePicker
                                showSecond={false}
                                minuteStep={10}
                                defaultValue={times.start_time}
                                onChange={(time) =>
                                  handleDateTimeChange(
                                    time,
                                    "start_time",
                                    index
                                  )
                                }
                                style={{ fontFamily: "sans-serif", width: 100 }}
                              />
                              <div style={{ marginLeft: 20 }}>เวลาสิ้นสุด </div>
                              <TimePicker
                                showSecond={false}
                                minuteStep={10}
                                defaultValue={times.end_time}
                                onChange={(time) =>
                                  handleDateTimeChange(time, "end_time", index)
                                }
                                style={{ fontFamily: "sans-serif", width: 100 }}
                              />
                            </div>
                          )}
                        </div>
                      );
                    });
                  })()}
                </p>
                {errors.totalHoursAll && (
                  <div className="text-danger">{errors.totalHoursAll}</div>
                )}
              </Form.Group>

              <Form.Group controlId="activityHours" className="form-group">
                <Form.Label>จำนวนชั่วโมงทั้งหมดที่ทำกิจกรรมนี้</Form.Label>
                <InputGroup>
                  <Form.Control
                    disabled
                    type="number"
                    placeholder="กรอกจำนวนชั่วโมง"
                    step="1"
                    min="0"
                    value={totalHoursAll}
                  />
                </InputGroup>
              </Form.Group>

              <Form.Group controlId="activityPicture" className="form-group">
                <Form.Label>
                  รูปภาพกิจกรรมจำนวน 2 ภาพ{" "}
                  <span style={{ color: "red" }}>*</span>{" "}
                  <p
                    style={{
                      color: "black",
                      fontSize: 18,
                      fontWeight: "normal",
                    }}
                  >
                    หมายเหตุ:
                    รูปภาพกิจกรรมจะต้องเห็นใบหน้าของนักศึกษาขณะทำกิจกรรมอย่างชัดเจน
                    และรูปภาพต้องมีขนาดไม่เกิน 25 MB
                  </p>{" "}
                </Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  multiple
                  name="activity_pictures" // add this line
                  onChange={(e) =>
                    setActivityPictures([
                      ...activityPictures,
                      ...e.target.files,
                    ])
                  }
                />
                <div>
                  {activityPictures &&
                    activityPictures.map((file, index) => (
                      <div
                        key={index}
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <img
                          src={URL.createObjectURL(file)}
                          alt={file.name}
                          style={{
                            width: 120,
                            height: 120,
                            marginTop: 10,
                            padding: 10,
                          }}
                        />
                        <button
                          onClick={(event) => handleDeletePicture(event, index)}
                          style={{
                            position: "absolute",
                            marginTop: 10,
                            top: 0,
                            right: 0,
                            padding: "1px 3px",
                            borderRadius: "50%",
                            background: "red",
                            color: "white",
                            border: "none",
                            cursor: "pointer",
                          }}
                        >
                          X
                        </button>
                      </div>
                    ))}
                </div>
                {errors.activityPictures && (
                  <div className="text-danger">{errors.activityPictures}</div>
                )}
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              style={{ fontSize: 18 }}
              onClick={() => handleFormSubmitModal()}
            >
              เพิ่มข้อมูลกิจกรรม
            </Button>
            <Button
              variant="secondary"
              onClick={() => {
                setSelectedActivity(null);
                setActivityPosition("");
                setActivityHours("");
                setActivityPictures([]);
                setSelectedDates([]);
                setActivityTimes([]);
              }}
              style={{ fontSize: 18 }}
            >
              ปิด
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      {loading && <Loader className="thai-font" />}
    </div>
  );
};

export default Student_Form;
